import { University, ExchangeProgram } from '@/shared/models/view/university-viewmodel';
import { IUniversity, IExchangeProgram } from '@/shared/models/api/university-model';

export class UniversityMapper {
    public mapUniversity(university: IUniversity): University {
        return new University(
            university.id,
            university.description,
            university.exchangePrograms.map(entry => this.mapExchangeProgram(entry))
        )
    }

    public mapExchangeProgram(exchangeProgram: IExchangeProgram): ExchangeProgram {
        return new ExchangeProgram(
            exchangeProgram.id,
            exchangeProgram.description,
            exchangeProgram.validity.begin,
            exchangeProgram.validity.end,
            (exchangeProgram.programOfStudy ? exchangeProgram.programOfStudy.objectId : '')
        )
    }
}